module.exports = __webpack_public_path__ + "static/image/font/pc/bmkiranghaerang-6@3x.ver2_0_2.jpg?28c0dd5c";